<template>
  <div class="form-progress">
    <el-steps
      :active="currentStep - 1"
      align-center
      finish-status="success"
    >
      <el-step
        :title="i18n('teamRegistrationSite.form.step1.title')"
        @click.native="() => goTo(1)"
      />
      <el-step
        :title="i18n('teamRegistrationSite.form.step2.title')"
        @click.native="() => goTo(2)"
      />
      <el-step
        :title="i18n('teamRegistrationSite.form.step3.title')"
        @click.native="() => goTo(3)"
      />
      <el-step
        :title="i18n('teamRegistrationSite.form.step4.title')"
        @click.native="() => goTo(4)"
      />
      <el-step
        :title="i18n('teamRegistrationSite.form.step5.title')"
        @click.native="() => goTo(5)"
      />
    </el-steps>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import { i18n } from '@shared/i18n'

export default {
  name: 'appFormProgress',
  data() {
    return { i18n }
  },
  computed: {
    ...mapState('form', ['currentStep']),
  },
  methods: {
    ...mapActions('form', ['goToStep']),
    goTo(step) {
      if (this.currentStep === 6) return 
      this.goToStep(step)
    },
  },
}
</script>

<style lang="scss">
.form-progress {
  .el-step__title {
    font-size: 9px;
    line-height: 1.2;
    text-transform: none;
    font-weight: 300;
    margin-top: 4px;

    @include mobile {
      font-size: 10px;
    }
  }

  .el-step__icon {
    width: 20px;
    height: 20px;
    font-size: 10px;
    cursor: pointer;

    @include tablet {
      width: 30px;
      height: 30px;
    }

    &-inner,
    &-inner::before {
      font-size: 10px !important;
      font-weight: 400;

      @include tablet {
      font-size: 12px !important;
      }
    }
  }

  .el-step__head.is-wait {
    .el-step__icon {
      background-color: #ffffff;
      color: #c5c5c5;
    }
  }
}
</style>
